export const appVersion = '0.10.0';
